const volunteerServicesFields = {
    need:{default:"",label:"",width:12},

    notes:{default:"",label:"",width:12,multiline:true,rows:4},
    
}

export default volunteerServicesFields